<app-top-nav></app-top-nav>
@if (!swapRequestService.hasEnoughImages() && !warningBannerClosed) {
  <div class="property-warning-banner" id="propertyWarningBanner">
    <span class="property-warning-text">
      ⚠️ {{ "warning.noPropertyPhotos" | translate }}
      <a routerLink="/my-request/edit" fragment="propertyPhotos">{{ "warning.noPropertyPhotosClickToUpload" | translate }}</a>
    </span>
    <button class="property-warning-close" (click)="closeWarningBanner()">&times;</button>
  </div>
}
<div
  class="dashboard_grid"
  [ngClass]="{
    'with-warning-banner': !swapRequestService.hasEnoughImages() && !warningBannerClosed,
  }">
  <div class="content" #content>
    <div class="body-content">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>

<app-bottom-nav></app-bottom-nav>
